import type { HealthPromotionParseResult } from './healthPromotionTypes';
import { parseWellhubFile, parseCurrencyValue } from './parsers/wellhubParser';

export { parseCurrencyValue };

export async function parseHealthPromotionFile(file: File): Promise<HealthPromotionParseResult> {
  // Strategy Pattern: Detect provider based on file content or name
  // Currently only Wellhub is supported.

  // Potential sniffing logic:
  // if (matchesWellhub(file)) return parseWellhubFile(file);

  // Defaulting to Wellhub for now as it's the only one.
  try {
    return await parseWellhubFile(file);
  } catch (err: any) {
    if (err.message?.includes('Cabeçalho não identificado')) {
      throw new Error('Arquivo não reconhecido como relatório Wellhub. Verifique o formato.');
    }
    throw err;
  }
}
